<script>
    import StepsProgressBar from '../common/sidebar/StepsProgressBar.svelte'
    import AppComponent from '../common/AppComponent.svelte'
    import RegistrationPage from '../registration/RegistrationPage.svelte'
    import { registerPageState } from './registeredUser.js'
</script>

<StepsProgressBar currentPage={1}/>
<AppComponent nextPage="#/organizations" nextPageEnabled={$registerPageState}>
    <RegistrationPage />
</AppComponent>
